import { FC, useState } from 'react';
import { Button } from '@bfe/moly';
import { Block } from '@/components/block';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import { appPath } from '@web3/base-utils';

import 'swiper/css';
import 'swiper/css/effect-fade';

import styles from './index.module.scss';
import { useFm, useParams } from '@web3/base-hooks';
import DownloadModal from '@/components/downloadModal';

interface WalletInfoContainerProps {}

const HIDDEN_LIST: {
  [key: string]: string[];
} = {
  cloudWallet: ['en-NL', 'nl-NL'],
  keylessWallet: ['en-NL', 'nl-NL'],
};

export const WalletInfoContainer: FC<WalletInfoContainerProps> = () => {
  const fm = useFm();
  const [realIndex, setRealIndex] = useState(0);
  const [mainSwiper, setMainSwiper] = useState<SwiperClass>();
  const [modalVisible, setModalVisible] = useState(false);
  const { locale } = useParams();

  const dataList = [
    {
      title: fm('cloudWallet'),
      desc: fm('cloudWalletDesc'),
      icon: (
        <img
          src={`${appPath}/png/home/walletInfo/1.png`}
          alt={fm('cloudWallet')}
        />
      ),
      tag: 'cloudWallet',
    },
    {
      title: fm('seedPhraseWallet1'),
      desc: fm('seedPhraseWalletDesc'),
      icon: (
        <img
          src={`${appPath}/png/home/walletInfo/2.png`}
          alt={fm('seedPhraseWallet1')}
        />
      ),
      tag: 'seedPhraseWallet1',
    },
    {
      title: fm('keylessWallet'),
      desc: fm('keylessWalletDesc'),
      icon: (
        <img
          src={`${appPath}/png/home/walletInfo/3.png`}
          alt={fm('keylessWallet')}
        />
      ),
      tag: 'keylessWallet',
    },
  ].filter((item) => !HIDDEN_LIST[item.tag]?.includes(locale ?? ''));

  const onChangeSwiper = (index: number) => {
    mainSwiper?.slideToLoop(index);
    setRealIndex(index);
  };

  return (
    <Block clsName={styles.walletInfoBoxWrapper} noHeader full>
      <div className={styles.walletInfoBox}>
        <div className={styles.header}>
          <div className={styles.title}>{fm('ourWalletsSafeEasy')}</div>
        </div>

        <div className={styles.body}>
          <div className={styles.container}>
            <div className={styles.left}>
              <div className={styles.texts}>
                {dataList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`${styles.t} ${styles[`t${index + 1}`]} ${index === realIndex ? styles.active : ''}`}
                      onClick={() => onChangeSwiper(index)}
                    >
                      {item.title}
                    </div>
                  );
                })}
              </div>
              <div className={styles.actions}>
                <Button
                  variant="primary"
                  // size="large"
                  onClick={() => {
                    setModalVisible(true);
                  }}
                >
                  {fm('download')}
                </Button>
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.area}>
                <Swiper
                  onSwiper={setMainSwiper}
                  effect="fade"
                  fadeEffect={{
                    crossFade: true,
                  }}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  modules={[Autoplay, EffectFade]}
                  onSlideChangeTransitionEnd={(swiper) => {
                    setRealIndex(swiper.realIndex);
                  }}
                >
                  {dataList.map((item, index) => {
                    return (
                      <SwiperSlide key={index}>
                        <div className={styles.swiperBox}>
                          <p className={styles.desc}>{item.desc}</p>
                          <div className={styles.image}>{item.icon}</div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>
              <div className={styles.actions}>
                <Button
                  variant="primary"
                  size="small"
                  onClick={() => {
                    setModalVisible(true);
                  }}
                >
                  {fm('download')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DownloadModal
        visible={modalVisible}
        onClose={() => {
          setModalVisible(false);
        }}
      />
    </Block>
  );
};
